import React from 'react';
import cn from 'classnames';
import { views } from '../../../constants/views';
import { modes } from '../../../constants/modes';
import { useCalendarState } from '../../../context/CalendarContext';
import styles from '../CalendarGrid.module.scss';

const commonStyle = {
  gridColumn: '1/2',
  left: 0,
  zIndex: 10,
};

const CornerCell = () => {
  const { view, mode } = useCalendarState();

  return (
    <>
      <div
        className={styles.sideCellWrapper}
        style={{
          ...commonStyle,
          gridRow: '1/2',
          top: view === views.day ? 0 : '104px',
        }}
      />
      {mode === modes.calendar && view !== views.month && (
        <div
          className={cn(styles.sideCellWrapper, styles.borderBottom)}
          style={{
            ...commonStyle,
            gridRow: '2/3',
            top: view === views.day ? '104px' : '152px',
          }}
        >
          <p className={styles.daylongText}>Весь день</p>
        </div>
      )}
    </>
  );
};

export default CornerCell;
